import React, { FC, memo } from "react";
import { ISvG } from "~/types/SvGTypes";

const Icon: FC<ISvG> = ({ fill = "#EC8C22" }) => {
  return (
    <svg
      width="17"
      height="14"
      viewBox="0 0 17 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M16 1L5.6875 13L1 7.54545"
        stroke={fill}
        strokeWidth="2"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default memo(Icon);
